import { Container, Image, Row, Col, Stack } from "react-bootstrap";
import arrow from "../../assets/arrow.svg";
import { Link } from "react-router-dom";

const OurProject = ({ data }) => {

  const getLastData = (data) => {
    const lastData = data[data.length - 1];
    console.log("Last data : ",lastData);
    return lastData || null;
  }

  const { title, description, project_type, image_url } = getLastData(data);

  return (
    <div className="w-100 py-5">
      <Container className="d-flex justify-content-center">
        <div className="col-10 m-0">
          <div className="d-flex justify-content-between pb-2">
            <p className="fw-bold" style={{ fontSize: "36px" }}>
              Our Projects
            </p>
            <div className="d-flex align-items-center gap-2">
              <Link
                to={"/project"}
                className="fw-semibold m-0"
                style={{
                  fontSize: "24px",
                  whiteSpace: "nowrap",
                  color: "#E87012",
                  paddingBottom: "7px",
                }}
              >
                Explore our projects
              </Link>
              <img src={arrow} alt="icon" />
            </div>
          </div>
          <Row>
            <Col>
              <Stack gap={3}>
                <Image
                  src={image_url[1].image_url}
                  className="w-100"
                  rounded
                />
                <div className="parentBackground">
                  <div className="d-flex flex-column justify-content-end align-items-start text-white backgroundProject">
                    <h3>{title}</h3>
                    <h4>- {project_type}</h4>
                    <p>
                      {description}
                    </p>
                  </div>
                  <Image
                    src={image_url[0].image_url}
                    className="w-100"
                    rounded
                  />
                </div>
              </Stack>
            </Col>
            <Col>
              <Stack gap={3}>
                <div className="parentBackground">
                  <div className="d-flex flex-column justify-content-end align-items-start text-white backgroundProject">
                    <h3>{title}</h3>
                    <h4>- {project_type}</h4>
                    <p>
                      {description}
                    </p>
                  </div>
                  <Image
                    src={image_url[0].image_url}
                    className="w-100"
                    rounded
                  />
                </div>
                <Image
                  src={image_url[1].image_url}
                  className="w-100"
                  rounded
                />
              </Stack>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default OurProject;
